import { RegistrationDependenciesFactory } from "./dependencies.factory";

export const registrationEpicDependencies = {
    registrationService   : RegistrationDependenciesFactory.getRegistrationService(),
    registrationRepository: RegistrationDependenciesFactory.getRegistrationRepository(),
    cityService           : RegistrationDependenciesFactory.getCityService()
}
